import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await axios.post("https://shivansh-portfolio-nkyo.onrender.com/api/admin/login", { username, password });
      localStorage.setItem("token", res.data.token);
      alert("Admin Login Successful!");
      navigate("/admin-dashboard"); // Redirect to Admin Dashboard
    } catch (error) {
      alert("Invalid Credentials");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg text-center">
        <h2 className="text-2xl font-bold mb-4">🔑 Admin Login</h2>
        <input type="text" placeholder="Username" className="w-full p-2 mb-2 bg-gray-700 text-white"
          value={username} onChange={(e) => setUsername(e.target.value)} />
        <input type="password" placeholder="Password" className="w-full p-2 bg-gray-700 text-white"
          value={password} onChange={(e) => setPassword(e.target.value)} />
        <button onClick={handleLogin} className="bg-blue-500 mt-4 px-4 py-2 rounded hover:bg-blue-700">
          Login
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
